import { TagsManagerBaseDataProvider } from './TagsManagerBaseDataProvider';
import { ConsoleRequest, CreateRequestPayload, DataProviderType } from '../../../utils/request';
import { TagsMethods } from '../../tagsManagerGrid/types';

export class TagsManagerGzDataProvider extends TagsManagerBaseDataProvider {
  private endpoint = 'GzTags';

  public async removeGzTagRecords(payload: CreateRequestPayload['payload'], allSelected: boolean): Promise<object> {
    return await ConsoleRequest.createRequest<object>({
      dataProviderType: DataProviderType.ENDPOINTS,
      endpoint: this.endpoint,
      payload: payload,
      method: allSelected ? TagsMethods.REMOVE_BY_FILTER : TagsMethods.REMOVE_RECORDS,
    });
  }
}
